export default "__VITE_ASSET__CeuFeE6M__"